import { reactive, toRefs, watch } from 'vue';
import { useContext } from '@/compat';

/**
 * This function is for watching changes on the router.
 * @param {function} onChange - Callback fn
 * @returns {object} object - Current route and router
 * @example{
 *   const { route, router } = useRouter(newRouter);
 *
 *   return{
 *     route: Current route instance
 *     router: Current router instance
 *   }
 * }
 */
export const useRouter = onChange => {
  const { route, $router } = useContext();
  const state = reactive({ route });

  watch(
    () => route,
    r => {
      state.route = r;
      onChange && onChange(r);
    },
    { deep: true },
  );

  return { ...toRefs(state), router: $router };
};
